/** Textos de WhatsApi › Conversas (spec 2026-11-02 conversas §5.7). Os códigos de erro das
 *  rotas moram em `admin/whatsappGateways/mensagens.ts`, que a seção do gateway também usa. */

import type { AutorDaMensagem, EstadoDaConversa } from '@/api/whatsapiOrg'

export const ROTULO_DO_AUTOR: Record<AutorDaMensagem, string> = {
  tecnico: 'Técnico',
  bot: 'Bot',
  humano: 'Atendente',
  auto_reply: 'Resposta automática',
  api: 'Envio pela API',
}

export const ROTULO_DO_ESTADO: Record<EstadoDaConversa, string> = {
  aguardando: 'Aguardando humano',
  em_atendimento: 'Em atendimento',
  bot: 'Com o bot',
}

/** Ordem dos grupos da lista: quem espera uma pessoa vem primeiro (spec §2). */
export const ORDEM_DOS_ESTADOS: EstadoDaConversa[] = ['aguardando', 'em_atendimento', 'bot']

// `bot_decisao`/`bot_motivo` do WhatsApi (bot/index.js e inbound.js, spec §5.2).
const DECISOES: Record<string, string> = {
  respondeu: 'respondeu',
  transbordo: 'transbordo',
  pausado: 'pausado',
  fora_da_lista: 'fora da lista',
  descartado: 'descartado',
  sem_base: 'sem base',
  erro: 'erro',
}

const MOTIVOS: Record<string, string> = {
  sem_trecho: 'sem resposta na base',
  pedido_humano: 'pediu um atendente',
  erro_llm: 'falha do modelo',
  sentinela: 'resposta barrada pela verificação',
  atendimento_humano: 'em atendimento',
  assumida_durante_geracao: 'assumida durante a geração',
}

/** "transbordo · sem resposta na base", "pausado · em atendimento", "fora da lista"… */
export function decisaoDoBot(decisao: string | null, motivo: string | null): string | null {
  if (!decisao) return null
  const d = DECISOES[decisao] ?? decisao
  return motivo ? `${d} · ${MOTIVOS[motivo] ?? motivo}` : d
}

/** "29:59" até `pausadoAte` (ou "1:05:00" acima de uma hora); "00:00" quando já venceu. */
export function voltaAoBotEm(pausadoAte: string, agora: number): string {
  const total = Math.max(0, Math.floor((new Date(pausadoAte).getTime() - agora) / 1000))
  const p = (n: number) => String(n).padStart(2, '0')
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  return h > 0 ? `${h}:${p(m)}:${p(s)}` : `${p(m)}:${p(s)}`
}

/** "14:05" hoje; "01/11 14:05" em outro dia. */
export function horario(iso: string, agora: number = Date.now()): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  const p = (n: number) => String(n).padStart(2, '0')
  const hora = `${p(d.getHours())}:${p(d.getMinutes())}`
  return d.toDateString() === new Date(agora).toDateString()
    ? hora
    : `${p(d.getDate())}/${p(d.getMonth() + 1)} ${hora}`
}
